import type { AxiosResponse } from "axios";

import api from "../../../../../api";
import type { IUser } from "../../../../../types";

export const handleDeleteEndlessDatevExports = async (
  user: IUser
): Promise<AxiosResponse> => {
  return await api.kontax.deleteEndlessDatevExports(user.id);
};
